export const ResizeIcon = () => (
  <svg width="8" height="8" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.16578 0.624026C1.44241 0.347405 1.8909 0.347405 2.16752 0.624026L11.3759 9.83236C11.6525 10.109 11.6525 10.5575 11.3759 10.8341C11.0992 11.1107 10.6507 11.1107 10.3741 10.8341L1.16578 1.62576C0.889163 1.34914 0.889162 0.900648 1.16578 0.624026Z"
      fill="var(--color-icon-secondary)"
    />
    <path
      d="M6.12412 0.624026C6.40074 0.347405 6.84923 0.347405 7.12585 0.624026L11.3759 4.87403C11.6525 5.15065 11.6525 5.59914 11.3759 5.87576C11.0992 6.15238 10.6507 6.15238 10.3741 5.87576L6.12412 1.62576C5.8475 1.34914 5.8475 0.900648 6.12412 0.624026Z"
      fill="var(--color-icon-secondary)"
    />
  </svg>
);
